import React from 'react'

interface SpacerProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Spacing top, using React.CSSProperties['marginTop']:
   * sets the margin area on the top of an element.
   * A positive value places it farther from its neighbors,
   * while a negative value places it closer.
   */
  spaceTop?: React.CSSProperties['marginTop']
  /**
   * Spacing bottom, using React.CSSProperties['marginBottom']:
   * sets the margin area on the bottom of an element.
   * A positive value places it farther from its neighbors,
   * while a negative value places it closer.
   */
  spaceBottom?: React.CSSProperties['marginBottom']
  /**
   * Spacing left, using React.CSSProperties['marginLeft']:
   * sets the margin area on the left of an element.
   * A positive value places it farther from its neighbors,
   * while a negative value places it closer.
   */
  spaceLeft?: React.CSSProperties['marginLeft']
  /**
   * Spacing right, using React.CSSProperties['marginRight']:
   * sets the margin area on the right of an element.
   * A positive value places it farther from its neighbors,
   * while a negative value places it closer.
   */
  spaceRight?: React.CSSProperties['marginRight']
}

export const Spacer: React.FC<SpacerProps> = ({
  spaceTop,
  spaceBottom,
  spaceLeft,
  spaceRight,
  ...rest
}) => {
  const styles: React.CSSProperties = {
    marginTop: spaceTop,
    marginBottom: spaceBottom,
    marginLeft: spaceLeft,
    marginRight: spaceRight,
  }

  return <div style={styles} {...rest} />
}
